import Echo from 'laravel-echo';

import Pusher from 'pusher-js';
window.Pusher = Pusher;

// Prefer server-provided config (from .env at runtime) so REVERB_HOST etc. can change without rebuilding
const serverConfig = (window as Window & { reverbConfig?: { host: string; port: number; scheme: string; key: string } }).reverbConfig;
const reverbAppKey = serverConfig?.key ?? import.meta.env.VITE_REVERB_APP_KEY;
const reverbHost = serverConfig?.host ?? import.meta.env.VITE_REVERB_HOST;
const reverbPort = serverConfig?.port ?? import.meta.env.VITE_REVERB_PORT;
const reverbScheme = (serverConfig?.scheme ?? import.meta.env.VITE_REVERB_SCHEME) ?? 'https';

// Normalize port: 443/80 from config are for client; wsPort/wssPort expect number
const wsPort = reverbScheme === 'wss' || reverbScheme === 'https' ? 443 : 80;
const wssPort = 443;

if (!reverbAppKey) {
    console.warn('REVERB_APP_KEY is not set. Pusher/Reverb will not be initialized.');
} else if (!reverbHost) {
    console.warn('REVERB_HOST is not set. Pusher/Reverb will not be initialized.');
} else {
    try {
        window.Echo = new Echo({
            broadcaster: 'reverb',
            key: reverbAppKey,
            wsHost: reverbHost,
            wsPort: Number(reverbPort) || wsPort,
            wssPort: wssPort,
            forceTLS: reverbScheme === 'https' || reverbScheme === 'wss',
            enabledTransports: ['ws', 'wss'],
        });

        console.log('Pusher/Reverb initialized successfully');
    } catch (error) {
        console.error('Failed to initialize Pusher/Reverb:', error);
        console.warn('Pusher/Reverb will not be available.');
    }
}
